export const environment = {
    production: false,
    ambiente: 'DEV',
    cookieDomain: undefined,
    // api: 'https://geradorpropostashomolog.azurewebsites.net/',
    api: 'https://localhost:5001/',
    institutionalSite: 'https://gray-smoke-0c219ad0f.2.azurestaticapps.net',
    sistemaVO: 'https://voenerzeehomolog.azurewebsites.net/'
};